import Image from "next/image";
import GridElement from "../GridElement";
import GridWrapper from "../GridWrapper";
import bgArrows from "../../public/bg_graphics/arrows_in.svg";

interface BackgroundGraphicProps {
  bgHeight?: number;
  align?: "left" | "right";
}

const BackgroundGraphic = ({
  bgHeight = 70,
  align = "right",
}: BackgroundGraphicProps) => {
  return (
    <GridWrapper
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: -1,
      }}
    >
      <GridElement
        gridLayout={
          align === "right"
            ? [
                [961, 10, 7],
                [1401, 19, 14],
              ]
            : [
                [961, 1, 7],
                [1401, 1, 14],
              ]
        }
      >
        <div style={{ position: "relative", height: `${bgHeight}vh` }}>
          <Image
            src={bgArrows}
            alt="background arrows"
            layout="fill"
            objectFit="contain"
            priority={true}
          />
        </div>
      </GridElement>
    </GridWrapper>
  );
};

export default BackgroundGraphic;
